
/**
 * API configuration settings
 */

// Base URL for API requests
export const API_BASE_URL = "https://api.discoveryconciergeservices.com";

// API endpoint prefix - typically you won't need to change this
export const API_PREFIX = "/api/v1/";

// Complete API base URL with prefix
export const API_URL = `${API_BASE_URL}${API_PREFIX}`;

/**
 * Change this value to point to a different API environment
 * Examples:
 * - Production: https://api.discoveryconciergeservices.com
 * - Development: https://unique-notable-bulldog.ngrok-free.app
 * 
 * Just update API_BASE_URL to switch environments across the entire application
 */
